module.exports = __webpack_public_path__ + "img/creation.5c8247ac.jpg";